var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-map',{ref:"gmap",attrs:{"id":"map","center":{ lng: -100, lat: 38.7 },"zoom":4.9,"options":_vm.options}},_vm._l((_vm.markers),function(marker){return _c('google-marker',{key:marker.id,attrs:{"clickable":true,"draggable":false,"position":marker.position,"icon":_vm.getMarkerOptions(marker.icon)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }